<template>
    <div>
        <div class="text-center col-12 my-5" v-show="isLoading">
            <span class="spinner-border" role="status"></span>
        </div>
        <Notification v-for="(notification, index) in notifications" :key="index" :notification="notification" v-show="!isLoading"></Notification>

        <div class="container mb-3" v-show="!isLoading && !notifications.length">
            <div class="row py-3">
                <div class="col-12 text-center">
                    <div class="mb-2">
                        <i class="far fa-comment fa-2x"></i>
                    </div>
                    <p class="mb-0">{{ $t('Du har ikke mottatt noen varsler enda.') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import Notification from './Notification'
import Store from '../../state/notificationStore'

Store.init()

const notifications = computed(() => Store.getNotifications())
const isLoading = computed(() => Store.isLoading())
</script>
